module.exports = __webpack_public_path__ + "img/main_plus.26081273.svg";